<template>
  <div>
        <!-- 小圆点 -->
    <ul class="circle-list">
      <li class="circle active" data-n="0">店收盈码牌</li>
      <li class="circle" data-n="1">店收盈云音箱</li>
      <li class="circle" data-n="2">客显屏音箱</li>
      <li class="circle" data-n="3">扫码盒</li>
      <li class="circle" data-n="4">智能pos</li>
      <li class="circle" data-n="5">定制云打印机</li>
    </ul>
    <!-- 图片列表 -->
    <div class="imgs">
      <div class="img-list">
        <img src="@/assets/new/product1.png" />
        <img src="@/assets/new/product2.png" />
        <img src="@/assets/new/product3.png" />
        <img src="@/assets/new/product4.png" />
        <img src="@/assets/new/product5.png" />
        <img src="@/assets/new/product6.png" />

      </div>

    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      // 获取左右按钮和图片列表
      let oImgList = document.querySelector(".img-list");

      // 克隆第一张图片
      let clonefirstImg = oImgList.firstElementChild.cloneNode();
      // 将第一张图片添加至图片列表的末尾
      oImgList.appendChild(clonefirstImg);

      // 图片索引 代表当前是第几张图片  index:0代表第一张图片
      let index = 0;


      // 获取五个小圆点
      const circles = document.querySelectorAll(".circle");

      // 小圆点高亮的显示
      function setCircles() {
        for (let i = 0; i < circles.length; i++) {
          if (i === index) {
            circles[i].classList.add("active");
          } else {
            circles[i].classList.remove("active");
          }
        }
      }

      // 小圆点点击切换图片 使用事件代理
      const oCircle = document.querySelector(".circle-list");
      oCircle.addEventListener("mouseover", (e) => {
        // 当我点击小圆点的时候
        if (e.target.nodeName.toLowerCase() === "li") {
          // 当前元素的data-n对应得值 和index一一对应
          const n = Number(e.target.getAttribute("data-n"));
          index = n;
          setCircles();
          oImgList.style.transition = "0.5s ease";
          oImgList.style.left = -index * 100 + '%';
        }
      });
    });
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
ul {
  list-style: none;
}

.imgs{
  overflow: hidden;
}
.img-list {
  display: flex;
  position: relative;
  left: 0px;
  width: 100%;
  height: 100%;
  transition: 0.5s ease;
}

 .img-list img {
  width: 100%;
  cursor: pointer;
}

.circle-list {
  color: #fff;
  display: flex;
  /* position: absolute; */
  width: 100%;
  height: 40px;
  z-index: 8;
  padding-top: 50px;
  border-bottom: 2px solid #fff;
}
.circle-list > .circle {
  text-align: center;
  width: 16.66%;
}

.circle-list > .circle.active {
  border-bottom: 2px solid #de1f26;
}
</style>
